import { ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';
import type { ChangeEvent, FormEventHandler, VoidFunctionComponent } from 'react';

import Button from '../../../../../generic/Button';
import { useAuthenticationSettingsContext } from '../../hooks';
import type { TestUser } from '../types';

import useTestLDAP from './hooks/useTestLDAP';
import LDAPTestResults from './LDAPTestResults';

type Props = {
  onHideTestModal: () => void;
  user: TestUser;
  updateTestUser: (key: keyof TestUser) => (e: ChangeEvent<HTMLInputElement>) => void;
};

const TestLDAPModal: VoidFunctionComponent<Props> = ({ onHideTestModal, user, updateTestUser }) => {
  const { settings } = useAuthenticationSettingsContext();
  const ldapConfig = settings.ldap;
  const { onTestLDAP, value, errors, isLoading } = useTestLDAP();

  return (
    <Modal show onHide={onHideTestModal}>
      <Modal.Header closeButton>
        <Modal.Title>Test LDAP Connection</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>FOSSA will connect to your LDAP server and attempt to log in using these credentials:</p>
        <FormGroup>
          <ControlLabel>Username</ControlLabel>
          <FormControl
            type="text"
            value={user.username}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange={updateTestUser('username') as FormEventHandler<any>}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Password</ControlLabel>
          <FormControl
            type="password"
            value={user.password}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange={updateTestUser('password') as FormEventHandler<any>}
          />
        </FormGroup>
        <div className="margin-top-lg margin-bottom-lg">
          <Button
            type="primary"
            size="medium"
            onClick={() => {
              if (ldapConfig) {
                onTestLDAP({ ldap: ldapConfig, user });
              }
            }}
          >
            Test Login
          </Button>
        </div>
        <h4>Results:</h4>
        <LDAPTestResults connectionTest={value} errors={errors} isLoading={isLoading} />
      </Modal.Body>
    </Modal>
  );
};

export default TestLDAPModal;
